import WidgetBase from "../widget.base";

export default class Banner extends WidgetBase {
    static selector = '[data-js-banner]';
    player = null;
    btnSelector = '[data-js-button-play]';
    constructor(el) {
        super(el);
        this.attachButtonControl();
        setTimeout(() => { this.autoplay(); }, 3000);
    }

    //Init the auto play for the banner video, if the user doesn't interact with the page It'll throw and error
    autoplay() {
        //Banner controls
        let button = this.el.querySelector(this.btnSelector);
        if (button) {
            let playerContainer = this.el.querySelector('.usc-banner__video-player');
            let video = playerContainer.querySelector('video');
            video
                .play()
                .then(() => {
                    if (playerContainer.classList.contains('usc-banner__video-player--hidden')) {
                        playerContainer.classList.remove('usc-banner__video-player--hidden');
                    }
                    button.classList.remove('usc-banner__play-toggle--will-play');
                    button.classList.add('usc-banner__play-toggle--will-pause');
                });
        }

    }

    attachButtonControl() {
        //Banner controls
        let button = this.el.querySelector(this.btnSelector);
        if (button) {
            let playerContainer = this.el.querySelector('.usc-banner__video-player');
            let video = playerContainer.querySelector('video');
            button.addEventListener(
                'click',
                () => {
                    if (playerContainer.classList.contains('usc-banner__video-player--hidden')) {
                        playerContainer.classList.remove('usc-banner__video-player--hidden');
                    }
                    if (!!(video.currentTime > 0 && !video.paused && !video.ended && video.readyState > 2)) {
                        button.classList.add('usc-banner__play-toggle--will-play');
                        button.classList.remove('usc-banner__play-toggle--will-pause')
                        video.pause();
                    }
                    else {
                        button.classList.remove('usc-banner__play-toggle--will-play');
                        button.classList.add('usc-banner__play-toggle--will-pause')
                        video.play();
                    }

                }
            );
        }
    }
}
